import { render } from "./DynamicFormPage.vue?vue&type=template&id=6c009c04&scoped=true"
import script from "./DynamicFormPage.vue?vue&type=script&lang=js"
export * from "./DynamicFormPage.vue?vue&type=script&lang=js"

import "./DynamicFormPage.vue?vue&type=style&index=0&id=6c009c04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c009c04"]])

export default __exports__